<template>
  <b-modal id="modal-request-detail" size="lg" title="Detail" hide-footer @show="setData">
    <div class="table-responsive">
      <strong>Main Data</strong>
      <!-- .table -->
      <table class="table" aria-label="Employee Detail">
        <!-- tbody -->
        <tbody>
        <!-- tr -->
        <tr>
          <th style="width: 25%;" id="employee">Employee</th>
          <td>{{detail.emp_name}}</td>
        </tr>
        <tr>
          <th id="leave-range">Leave Range</th>
          <td>{{ detail.start }} - {{detail.end}}</td>
        </tr>
        <tr>
          <th id="is-half-day">is Half Day?</th>
          <td>{{ detail.is_half_day ? 'Yes' : 'No' }}</td>
        </tr>
        <tr>
          <th id="nod">Nr of Days</th>
          <td>{{detail.day_count}}</td>
        </tr>
        <tr>
          <th id="old-balance">Old Balance</th>
          <td>{{ parseFloat(detail.old_balance).toFixed(2) }}</td>
        </tr>
        <tr>
          <th id="new-balance">New Balance</th>
          <td>{{ parseFloat(detail.new_balance).toFixed(2) }}</td>
        </tr>
        <tr>
          <th id="project">Project</th>
          <td>{{ detail.project_name }}</td>
        </tr>
        <tr>
          <th id="leave-type">Leave Type</th>
          <td>{{ detail.tipe_name }}</td>
        </tr>
        <tr>
          <th id="pic">PIC During Leave</th>
          <td>{{detail.contact_name}}</td>
        </tr>
        <tr>
          <th id="remarks">Remarks</th>
          <td>{{ detail.reason }}</td>
        </tr>
        <tr>
          <th id="leave-status">Leave Status</th>
          <td>{{detail.leave_stat_name}}</td>
        </tr>
        <tr>
          <th id="change-status">Change Status</th>
          <td>-</td>
        </tr>
        <tr>
          <th id="submitted">Submitted</th>
          <td>{{ detail.leave_stat_id > 0 ? detail.submit_timestamp :"" }}</td>
        </tr>
        <tr>
          <th id="modified">Modified</th>
          <td>{{ detail.last_modified }}</td>
        </tr>
        <tr>
          <th id="file">File</th>
          <td>
            <div class="list-group-item" style="cursor:pointer" v-if="imageExt.includes(getExtension(data.attachment_ori))" @click="downloadFile(detail.attachment_enc, data.attachment_ori, $event)">
              <div class="list-group-item-figure">

                <div class="tile tile-img">
                  <img :src="detail.attachment_enc" alt=""/>
                </div>
              </div>
              <div class="list-group-item-body">
                <div class="media align-items-center">
                  <div class="media-body">{{data.attachment_ori}}</div>
                </div>
              </div>
            </div>
            <div class="list-group-item" style="cursor:pointer" v-else-if="data.attachment_ori !== ''" @click="downloadFile(detail.attachment_enc, data.attachment_ori, $event)">
              <div class="list-group-item-figure">
                <div class="tile tile-circle" >{{data.attachment_ori.substring(0, 1)}}</div>
              </div>
              <div class="list-group-item-body">
                <h4 class="list-group-item-title">{{data.attachment_ori}}</h4>
                <p class="list-group-item-text">{{data.attachment_ori}}</p>
              </div>
            </div>
          </td>
        </tr>
        <!-- /tr -->
        </tbody>
      </table>
      <hr>
      <legend>Approval</legend>
      <template v-if="detail.leave_stat_id !== 0">
        <div class="form-group">
          <label class="control-label">Approval Information</label>
          <div class="table-responsive">
            <table class="table table-hover table-striped" aria-label="Approval Information">
              <thead>
              <tr>
                <th style="min-width:10px" id="level"> Level </th>
                <th id="name"> Name </th>
                <th id="email"> Email </th>
                <th id="status"> Status </th>
                <th id="date"> Date </th>
              </tr>
              </thead>
              <tbody >
              <tr v-for="(data, i) in list_supervisor">
                <td>{{data.level}}</td>
                <td>{{data.name}}</td>
                <td>{{data.email}}</td>
                <td>{{data.status_name}}</td>
                <td>{{data.status_date}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <list-supervisor v-else-if="this.$store.getters.companySettings.is_ot_auto_approve == 0" module="leave-request"></list-supervisor>

    </div>

  </b-modal>
</template>

<script>
import {BModal} from 'bootstrap-vue'
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "@/components/pages/employee/ListSupervisor";
export default {
  name: "LeaveRequestDetail",
  components:{
    BModal,
    ListSupervisor
  },
  props:{
    detail:{
      type:Object
    }
  },
  data(){
    return {
      list_supervisor:[],
      imageExt:['png', 'jpg', 'jpeg'],
      data :{
        attachment_ori:""
      }
    }
  },
  methods:{
    getListSupervisor(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.leave_request.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setData(){
      setTimeout(()=>{
        if(this.detail !== null){
          this.data.attachment_ori = (this.detail.attachment_ori == null) ? "" : this.detail.attachment_ori
          if(this.detail.leave_stat_id !== 0) this.getListSupervisor()
        }
      }, 100)
    },
    downloadFile(url, name, evt){
      evt.preventDefault()
      window.open(url, '_blank');
    },
    getExtension(filename){
      let re = /(?:\.([^.]+))?$/;

      let ext = re.exec(filename)[1];
      return ext
    },
  }
}
</script>